import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';

class SablonTipleriService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.SablonDomain + ApiUrl.controller.Tipleri);
    }

}

const sablonTipleriService = new SablonTipleriService();

export default sablonTipleriService;
